export default __webpack_public_path__ + "static/covid-virus-shape-img-ab3162d2549afe3dc1116d3189ed8fb3.png";